import { createAsyncThunk } from '@reduxjs/toolkit';
import { FetchMixin } from './FetchMixin';

// FetchMixinを適用したクラスを作成
class DataFetcher extends FetchMixin(Object) { }

// base64文字列をデコードしてバイナリデータに変換する関数
function decodeBase64(base64String) {
  const binaryString = atob(base64String);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
}

// データを解凍する非同期関数
async function decompressData(base64String) {
  // バイナリデータを取得
  const bytes = decodeBase64(base64String);

  // 以下の処理は元のコードと同じ
  const stream = new Response(bytes).body;
  const decompressionStream = new DecompressionStream('gzip');
  const decompressedStream = stream.pipeThrough(decompressionStream);
  const reader = decompressedStream.getReader();
  const chunks = [];
  let result;

  while (true) {
    result = await reader.read();
    if (result.done) {
      break;
    }
    chunks.push(result.value);
  }

  const concatenatedChunks = new Uint8Array(chunks.reduce((acc, chunk) => {
    const newChunk = new Uint8Array(acc.length + chunk.length);
    newChunk.set(acc);
    newChunk.set(chunk, acc.length);
    return newChunk;
  }, new Uint8Array()));

  const text = new TextDecoder().decode(concatenatedChunks);
  return text;
}

// 非同期アクション
export const fetchDataForEditorStores = createAsyncThunk(
  'data/fetchForEditorStores',
  async (_, { dispatch, getState, rejectWithValue }) => {
    const dataFetcher = new DataFetcher(); // DataFetcherのインスタンスを作成
    try {
      //urlパラメータからapplicationKeyとversionを取得
      const urlParams = new URLSearchParams(window.location.search);
      const appKey = urlParams.get('appKey');
      const version = urlParams.get('version');

      // fetchオプションを設定
      const options = {
        method: 'GET',
      }
      // .envからエンドポイントを読み込み
      const endpoint = process.env.EDITOR_JSON_ENDPOINT;
      // エディタ情報を取得するRESTAPIを呼び出し
      const response = await dataFetcher.fetchWithAuth(endpoint + "?appKey=" + appKey + "&version=" + version, options);
      if (response.code !== 200) {
        alertStore.dispatch(setAlert(response.message));
        throw new Error(response.message);
      }
      let details = response.details;
      //detailsのjsonのkeyを取得してループ
      let keys = Object.keys(details);

      // 全てのキーに対して非同期処理を行い、プロミスの配列を作成する
      let currentVersion = null;
      let aiCodingEnabled = false;
      let isUserGeminiApiKeyRegistered = false;
      let promises = keys.map(async (key) => {
        if (key === 'editorJsonVersion') {
          // 現在のバージョン
          currentVersion = atob(details[key]);
          details[key] = currentVersion;
        } else if (key === 'aiCodingEnabled') {
          aiCodingEnabled = details[key];
          details['userSettings'] = { 'aiCodingEnabled': aiCodingEnabled };
        } else if (key === 'isUserGeminiApiKeyRegistered') {
          isUserGeminiApiKeyRegistered = details[key];
          details['isUserGeminiApiKeyRegistered'] = isUserGeminiApiKeyRegistered;
        } else {
          let detail = details[key];
          let text = await decompressData(detail);
          details[key] = JSON.parse(text);
        }
      });
      // 全てのプロミスが解決するのを待つ
      await Promise.all(promises);
      details['modified'] = false;
      return details;

    } catch (error) {
      //localStorage.removeItem('editorDatas');
      return rejectWithValue(error.message);
    }
  }
);
